export const URLS = {
  app: 'https://app.mycrypto.com',
  support: 'https://support.mycrypto.com',
};

export const GITHUB_RELEASES_URL = 'https://github.proxy.mycryptoapi.com/';
export const GITHUB_RELEASE_NOTES_URL =
  'https://github.com/MyCryptoHQ/MyCrypto/releases/latest';
